var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowThickRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8 2.666-.94.94 3.72 3.727H2.665v1.333h8.113l-3.72 3.727.94.94 5.334-5.334-5.334-5.333z"
})));
export default SvgArrowThickRight;